module.exports = __webpack_public_path__ + "static/media/dwt-07.a28e67cb.jpg";